import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useEffect, useState, } from 'react';
const RouterContext = createContext(null);
export const Router = ({ children, initialRoute, }) => {
    const parent = useContext(RouterContext);
    const [activeRoute, setActiveRoute] = useState(initialRoute ? { name: initialRoute } : null);
    const navigate = useCallback((to, args = {}) => setActiveRoute({ name: to, ...args }), []);
    useEffect(() => {
        var _a;
        if (!parent) {
            return;
        }
        // If this is a nested router, we need to tell all child Routes that the active route is the nested one
        if ((_a = parent === null || parent === void 0 ? void 0 : parent.activeRoute) === null || _a === void 0 ? void 0 : _a.sub) {
            setActiveRoute(parent.activeRoute.sub);
        }
    }, [parent]);
    return (_jsx(RouterContext.Provider
    // If this is a nested router we want to have a single source of truth for the whole app, which is the parent router
    // When we update the parent's active route, that will propagate to all nested Routers
    , { 
        // If this is a nested router we want to have a single source of truth for the whole app, which is the parent router
        // When we update the parent's active route, that will propagate to all nested Routers
        value: { activeRoute, navigate: parent ? parent.navigate : navigate }, children: children }));
};
export const Route = ({ name, children }) => {
    var _a;
    const router = useContext(RouterContext);
    return ((_a = router === null || router === void 0 ? void 0 : router.activeRoute) === null || _a === void 0 ? void 0 : _a.name) === name ? _jsx(_Fragment, { children: children }) : null;
};
export const useRoute = () => {
    var _a;
    const context = useContext(RouterContext);
    if (!context) {
        throw new Error('useRoute must be used within Router');
    }
    const { activeRoute, navigate } = context;
    return {
        current: activeRoute,
        params: (_a = activeRoute === null || activeRoute === void 0 ? void 0 : activeRoute.params) !== null && _a !== void 0 ? _a : {},
        name: (activeRoute === null || activeRoute === void 0 ? void 0 : activeRoute.name) || null,
        navigate,
    };
};
//# sourceMappingURL=Router.js.map